import ClientServices from '../ClientServices/ClientServices';
import FormGeneration from '../FormGeneration/FormGeneration';
import './NewIntakeForm.css';

export default function NewIntakeForm({client, getForms, updateClientPage, services, toggleNotifications, fullClientServices, getFullClientServices}) {
  return (
    <div className='NewIntakeForm modal fade' id={`newIntakeFormModal`}  data-bs-keyboard="true">
        <div className="modal-dialog">
            <div className="modal-content formContainer">
                <div className="nav nav-tabs flex-row navigation" id="v-tab" role='tablist' aria-orientation="horizontal">
                    <button className="nav-link active" id='servicesTab' data-bs-toggle="tab" role="tab" aria-controls="services" aria-selected="true" data-bs-target="#services" type="button">
                        Select Services
                    </button>
                    <button className="nav-link" id='formGenerationTab' data-bs-toggle="tab" role="tab" aria-controls="formGeneration" aria-selected="false" data-bs-target="#formGeneration" type="button">
                        Generate Forms
                    </button>
                </div>
                <div className='content tab-content' id="v-tabContent">
                    <div className="tab-pane fade show active" id="services" role="tabpanel" aria-labelledby="servicesTab">
                        <ClientServices client={client} updateClientPage={updateClientPage} services={services} />
                    </div>
                    <div className="tab-pane fade" id="formGeneration" role="tabpanel" aria-labelledby="formGenerationTab">
                        <FormGeneration client={client} getForms={getForms} updateClientPage={updateClientPage} toggleNotifications={toggleNotifications} fullClientServices={fullClientServices} getFullClientServices={getFullClientServices} />
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}
